export function localNav() {
  if (!IS_TOUCH) {
    const $localNavContainer = $('.js-local-nav-container');
    if ($localNavContainer[0]) {
      let targetOffsetTop = '';
      const $localNavSticky = $('.js-local-nav-sticky');
      const LOCAL_NAV_INIT = function() {
        const targetOffset = $localNavContainer.offset();
        targetOffsetTop = targetOffset.top - $('#header-nav-container').height();
      };
      LOCAL_NAV_INIT();
      $(window).on('load debouncedresize', LOCAL_NAV_INIT);
      $(window).on('scroll debouncedresize', function() {
        const scrollTop = $(window).scrollTop();
        if (scrollTop >= targetOffsetTop) {
          $localNavSticky.addClass('is-sticky');
        } else {
          $localNavSticky.removeClass('is-sticky');
        }
      });
    }
  }
}